import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=21801504&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21801504')) {
      api.createRecord('21801504', component.options)
    } else {
      api.reload('21801504', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=21801504&", function () {
      api.rerender('21801504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/Icon.vue"
export default component.exports